import { createContextStore } from '@/shared/util/createContextStore';

export type OperationConfigState = {
  selectedSampleCodeLanguage: string | undefined;
  selectedSampleCodeVariant: string | undefined;
  selectedResponseKey: string | string[] | undefined;
  selectedRequestKey: string | undefined;
  isExpandRequestExample: boolean | undefined;
  hiddenTopNotificationIds: string[];
};

export type OperationConfigAction = {
  setSelectedSampleCodeLanguageVariant: (
    value: { language: string; variant: string } | undefined,
  ) => void;
  setSelectedResponseKey: (value: string | string[] | undefined) => void;
  setSelectedRequestKey: (value: string | undefined) => void;
  setIsExpandRequestExample: (value: boolean) => void;
  getState: () => OperationConfigState;
  setHiddenTopNotificationIds: (value: string[]) => void;
};

export const operationConfigInitialState: OperationConfigState = {
  selectedSampleCodeLanguage: undefined,
  selectedSampleCodeVariant: undefined,
  selectedResponseKey: undefined,
  selectedRequestKey: undefined,
  isExpandRequestExample: undefined,
  hiddenTopNotificationIds: [],
};

const [OperationConfigModelStoreProvider, useOperationConfigModelStore] = createContextStore<
  OperationConfigState,
  OperationConfigAction
>((set, get) => ({
  ...operationConfigInitialState,
  getState: () => get(),
  setSelectedSampleCodeLanguageVariant: (
    value: { language: string; variant: string } | undefined,
  ) => {
    set((state) => ({
      ...state,
      selectedSampleCodeLanguage: value?.language,
      selectedSampleCodeVariant: value?.variant,
    }));
  },
  setSelectedResponseKey: (value: string | string[] | undefined) => {
    return set((state) => ({
      ...state,
      selectedResponseKey: value,
    }));
  },
  setSelectedRequestKey: (value: string | undefined) => {
    return set((state) => ({
      ...state,
      selectedRequestKey: value,
    }));
  },
  setIsExpandRequestExample: (value: boolean) => {
    return set((state) => ({
      ...state,
      isExpandRequestExample: value,
    }));
  },
  setHiddenTopNotificationIds: (value: string[]) => {
    return set((state) => ({
      ...state,
      hiddenTopNotificationIds: value,
    }));
  },
}));

export { OperationConfigModelStoreProvider, useOperationConfigModelStore };
